var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify__center mb-4"},[_c('v-rating',{attrs:{"label":_vm.generateLabel,"rules":_vm.isItRequired,"value":_vm.defaultValue,"hint":_vm.field.hint,"length":"5","size":"30","hover":"","disabled":_vm.isDisabled},on:{"input":_vm.handleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }